import React from 'react';
import { ReactComponent as ErrorIcon } from 'qs-assets/Media/image-error.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return <ErrorIcon style={{ width, height, fill }} className={`errorIconComponent ${classes}`} />;
};
